import * as helpers from '../../../helpers';

export default class Message {
    static createMessage(text = 'Error', id = '1', type = 'error') {
        const messageContainer = document.createElement('div');

        helpers.addClass(messageContainer, `message -${type} js-custom-message`);
        messageContainer.innerHTML = `<h2>${type === 'error' ? 'Erreur' : 'Info'}</h2><p>${text}</p>`;
        messageContainer.setAttribute('id', id);

        return messageContainer;
    }

    static addErrorToBlock(errorText, messageId, insertTarget) {
        const message = document.querySelector(`#${messageId}`);
        const messagesToDelete = [...document.querySelectorAll('.message')]
            .filter((item) => { return !helpers.hasClass(item, 'js-custom-message'); });

        messagesToDelete.forEach((item) => {
            item.parentElement.removeChild(item);
        });

        if (message) {
            return;
        }

        const newMessage = Message.createMessage(
            errorText,
            messageId,
        );

        insertTarget.insertBefore(newMessage, insertTarget.firstChild);

        newMessage.scrollIntoView({
            block: 'center',
            behavior: 'smooth',
        });
    }

    static removeErrorFromBlock(messageID) {
        const message = document.querySelector(`#${messageID}`);

        if (message) {
            message.parentNode.removeChild(message);
        }
    }
}
